import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RouterService } from './core/services/router.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {


  constructor(
    private routerService: RouterService
  ) {}

  ngOnInit(): void {
    //Getting route that is set within *.routing.ts files 
    this.routerService.setupPageTitles();
  }
}
